import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import ALM from "./App";
import LoginScreen from "./LoginScreen";

function Root() {
  const [user,  setUser ] = useState(null);
  const [token, setToken] = useState(null);
  const [checking, setChecking] = useState(true);

  // Recuperar sesión guardada
  useEffect(() => {
    const t = localStorage.getItem("token");
    const u = localStorage.getItem("user");
    if (t && u) {
      // Verificar que el token sigue siendo válido
      fetch(`${process.env.REACT_APP_API_URL || "http://localhost:3001/api"}/auth/me`, {
        headers: { Authorization: `Bearer ${t}` }
      })
      .then(r => r.json())
      .then(data => {
        if (data.id) { setUser(data); setToken(t); }
        else { localStorage.removeItem("token"); localStorage.removeItem("user"); }
      })
      .catch(() => { localStorage.removeItem("token"); localStorage.removeItem("user"); })
      .finally(() => setChecking(false));
    } else {
      setChecking(false);
    }
  }, []);

  const handleLogin = (u, t) => { setUser(u); setToken(t); };
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null); setToken(null);
  };

  if (checking) return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",
      background:"#0f172a",color:"#fff",fontSize:14}}>
      Cargando…
    </div>
  );

  if (!user) return <LoginScreen onLogin={handleLogin}/>;

  return <ALM currentUser={user} token={token} onLogout={handleLogout}/>;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><Root/></React.StrictMode>);
